<template>
    <div class="lang">
        <div class="info">
            <div class="table">
                <table>
                    <caption>РЕЗУЛЬТАТЫ (Visit consultation, Postal consultation, View internet result)</caption>
                    <colgroup>
                        <col style="width: 25%">
                        <col>
                    </colgroup>
                    <tbody>
                        <tr>
                            <th scope="row">Для личного визита на консультацию</th>
                            <td class="left">
                                вы можете посетить Оздоровительно-диагностический центр в назначенное для консультации с
                                врачом время.<br>
                                Вас направят в отделение, соответствующее полученным результатам вашего обследования.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">В случае консультации</th>
                            <td class="left">
                                по почте результаты будут отправлены к назначенному дню консультации – результаты
                                поступят в течение 3 рабочих дней заказным письмом.<br>
                                Перед отправкой результатов вам поступит телефонный звонок от одной из медсестер,
                                которая направит вас на амбулаторный прием, если того потребуют результаты обследования.
                            </td>
                        </tr>
                        <tr>
                            <th scope="row">Просмотр результатов</th>
                            <td class="left">Если вы выберите просмотр результатов в режиме онлайн, результаты будут
                                представлены в разделе [Просмотр результатов] на Моей странице веб-сайта
                                Оздоровительно-диагностического центра Клиники Женского университета Ивха в Сеуле после
                                регистрации, начиная с даты, на которую была назначена консультация.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {

}
</script>